module.exports = {"data":{"site":{"siteMetadata":{"title":"Jeff Chan"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"The last time I had a  public blog  was in high school. The blog was titled  The Jeff Channel , and  The Geeky Jeffy Zone  prior to that…","fields":{"slug":"/blog-redux/"},"frontmatter":{"date":"03 August, 2018","title":"Blog Redux"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 394
// module chunks = 142629428675168